import { TextField } from '@material-ui/core'
import { Box } from '@mui/system'
import { Collapse } from 'antd'
import React from 'react'

const { Panel } = Collapse

const FacebookSetting = ({ facebookConfig, onFacebookChange }) => {
    const handleInputChange = (e) => {
        onFacebookChange({
            ...facebookConfig,
            [e.target.name]: e.target.value,
        })
    }

    return (
        <Collapse>
            <Panel header="Facebook">
                <Box
                    component="form"
                    sx={{
                        '& > :not(style)': { m: 1, width: { lg: '48%', xs: '100%' } },
                    }}
                    noValidate
                    autoComplete="off"
                >
                    <TextField
                        size="small"
                        name="appId"
                        value={facebookConfig.appId}
                        label="App ID"
                        onChange={handleInputChange}
                        variant="outlined"
                    />
                    <TextField
                        size="small"
                        name="pageId"
                        value={facebookConfig.pageId}
                        label="Page ID"
                        onChange={handleInputChange}
                        variant="outlined"
                    />
                    <TextField
                        size="small"
                        name="appSecret"
                        value={facebookConfig.appSecret}
                        label="App Secret"
                        onChange={handleInputChange}
                        variant="outlined"
                    />
                    <TextField
                        size="small"
                        name="facebookToken"
                        value={facebookConfig.facebookToken}
                        label="Facebook Token"
                        onChange={handleInputChange}
                        variant="outlined"
                    />
                </Box>
            </Panel>
        </Collapse>
    )
}

export default FacebookSetting
